import { createMuiTheme } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';
import { ptBR } from '@material-ui/core/locale';
//#bf139a
export default createMuiTheme(
  {
    palette: {
      type: 'light',
      primary: {
        main: '#ff8000',
        light: '#ff962e',
        // dark: '#001361',
      },
      warning: {
        main: amber['400'],
      },
      // secondary: {
      //   // main: '#F24B0F',
      // },
      // grey: {
      //   // 300: '#D8DEEE',
      //   // 200: '#F3F6F9',
      // },
      // divider: '#D8DEEE',
      // text: {
      //   primary: '#000000',
      //   // secondary: '#7B86A3',
      // },
    },
    mixins: {
      toolbar: {
        minHeight: 50,
      },
    },
    shape: {
      // borderRadius: 12,
    },
    typography: {
      fontFamily: 'Jaldi',
      h4: {
        color: '#222222',
      },
      h5: {
        color: '#222222',
      },
    },
  },
  ptBR,
);
